import { Image, Page, Text, View } from '@react-pdf/renderer'

import { paginateSkopSummary } from '@/utils'

import { getPdfBadgeColors, PDF_FALLBACK_LOGO_SRC } from '../pdfTheme'
import { styles } from '../styles'

export const Summary = ({ data, settings }) =>
  paginateSkopSummary(data ?? []).map((page, pageIndex) => (
    <Page
      key={`summary-page-${pageIndex}`}
      style={[styles.page, { paddingBottom: '1.5cm', paddingTop: '0.5cm' }]}
    >
      {pageIndex === 0 ? (
        <View
          style={{
            ...styles.summarySection,
            display: 'flex',
            flexDirection: 'row',
            marginVertical: '2cm',
          }}
        >
          <View style={styles.logoContainer}>
            {settings?.logo ? (
              <Image src={settings.logo} style={styles.logoImage} alt="Logo" />
            ) : (
              <Image
                src={PDF_FALLBACK_LOGO_SRC}
                style={styles.logoImage}
                alt="Logo skop"
              />
            )}
          </View>
          <View
            style={{
              ...styles.headerTitle,
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            <Text style={styles.coverTitle}>Diagnostic</Text>
            <Text
              style={[
                styles.chip,
                { fontSize: 16 },
                getPdfBadgeColors(settings?.color),
              ]}
            >
              {settings?.name}
            </Text>
          </View>
        </View>
      ) : null}

      {page.map((category, categoryIndex) => (
        <View
          key={`${category.name}-${pageIndex}-${categoryIndex}`}
          wrap={false}
        >
          <View
            style={[
              styles.summarySection,
              {
                flexDirection: 'row',
                alignItems: 'center',
              },
            ]}
          >
            <Text style={styles.title}>{category.name}</Text>

            <Text
              style={{
                borderBottom: '1px dotted #CCC',
                flexGrow: 1,
                marginHorizontal: '0.5cm',
              }}
            />
            <Text style={styles.title}>p.{category.pageNumber}</Text>
          </View>
          <View
            style={[
              styles.summarySection,
              {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: '0.5cm',
              },
            ]}
          >
            <Text style={styles.subTitle}>
              {category.quantity} {category.quantity > 1 ? 'unités' : 'unité'}
            </Text>
          </View>
        </View>
      ))}
      <View fixed style={{ height: '2cm' }}>
        <Text>&nbsp;</Text>
      </View>
    </Page>
  ))
